import {
  Slider,
  Newsletter,
  VideoPlayer,
  Tooltip,
  KlaviyoForm,
} from "../global";
import { initSection } from "../utils";
import logBeyondBrand from "@thebeyondgroup/brand";
// logBeyondBrand();
document.addEventListener("DOMContentLoaded", () => {
  initSection("slider-container", Slider);
  initSection("newsletter-form", Newsletter);
  initSection("video-container", VideoPlayer);
  initSection("tooltip-info", Tooltip);
  initSection("klaviyo-form", KlaviyoForm);

  if (document.querySelector("announcement-bar")) {
    document.body.classList.add("has_announcement");
  }
});
